import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/admin.scss';
import { useSeo } from '../utils/seo';

const ADMIN_EMAIL = 'pinkyjh28@gmail.com';
const ADMIN_PASSWORD = 'Admin@1234';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  useSeo({
    title: 'Admin | Aavjo Industries',
    description: 'Aavjo Industries admin panel',
    path: '/admin-panel',
    robots: 'noindex, nofollow',
  });

  useEffect(() => {
    if (localStorage.getItem('adminLoggedIn') === 'true') {
      navigate('/admin-panel/dashboard', { replace: true });
    }
  }, [navigate]);

  const handleLogin = () => {
    if (!email.trim() || !password.trim()) {
      setError('Please fill in all fields.');
      return;
    }
    if (email.trim() === ADMIN_EMAIL && password === ADMIN_PASSWORD) {
      localStorage.setItem('adminLoggedIn', 'true');
      navigate('/admin-panel/dashboard', { replace: true });
    } else {
      setError('Invalid credentials');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleLogin();
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-logo">
          <span className="logo-icon">⚙️</span>
          <h1>Admin Panel</h1>
          <p>Aavjo Industries</p>
        </div>

        {error && <div className="admin-error">{error}</div>}

        <div className="admin-field">
          <label htmlFor="admin-email">Email</label>
          <input
            id="admin-email"
            type="email"
            value={email}
            placeholder="admin@example.com"
            autoComplete="username"
            onChange={(e) => { setEmail(e.target.value); setError(''); }}
            onKeyDown={handleKeyDown}
          />
        </div>

        <div className="admin-field">
          <label htmlFor="admin-password">Password</label>
          <div className="password-wrap">
            <input
              id="admin-password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              placeholder="••••••••"
              autoComplete="current-password"
              onChange={(e) => { setPassword(e.target.value); setError(''); }}
              onKeyDown={handleKeyDown}
            />
            <span
              className="toggle-pw"
              onClick={() => setShowPassword((prev) => !prev)}
              title={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? '🙈' : '👁️'}
            </span>
          </div>
        </div>

        <div className="admin-login-btn" onClick={handleLogin}>
          Sign In
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
